// tslint:disable:object-literal-key-quotes
export const frCA = {
    'product-name': 'Prism',
    'actions': {
        'close': 'Fermer',
        'create-account': 'Créer un compte',
        'account': 'Compte',
        'continue': 'Continuer',
        'login': 'Se connecter',
        'logout': 'Déconnexion',
        'save': 'Sauvegarder',
        'send': 'Envoyer',
        'delete': 'Supprimer',
        'upload': 'Téléverser',
        'cancel': 'Annuler',
        'apply': 'Accepter',
        'on': 'Activé',
        'off': 'Désactivé',
        'add': 'Ajouter',
        'validation': 'Validation'
    },
    'time': {
        'is24': true,
        'last-modified': 'Dernière modification',
        'created': 'Création'
    },
    'errors': {
        'unknown': 'Une erreur est survenue.',
        'wrong-username-or-password': 'Nom d\'utilisateur ou mot de passe invalide.',
        'email-not-verified': 'Vous devez vérifier votre courriel',
        'email-already-in-use': 'Cette adresse courriel est déjà associée à un autre compte.',
        'requires-recent-login': 'Veuillez entrer votre mot de passe.',
        'expired-or-invalid-action-code': 'Le lien que vous avec utilisé est expiré ou invalide.',
        'invalid-pin': 'Le nip entré est invalide ou expiré.',
        'unable-to-link-device': 'Impossible de lier cet appareil à votre compte.',
        'unable-to-name-device': 'Une erreur est survenue lors du nommage de cet appareil.',
        'insufficient-rights': 'Vous n\'avez pas les droits suffisants pour accéder à cette section.',
        'object-not-found': 'La section à laquelle vous tentez d\'accéder est introuvable.',
        'invalid-data': 'Les données auxquelles vous tentez d\'accéder sont invalides.',
        'saving-error': 'Échec lors de la sauvegarde.',
        'delete-error': 'Échec lors de la suppression.',
        'required-field': 'Ce champ est nécessaire',
        'require-valid-email': 'Veuillez entrer une adresse courriel valide',
        'enter-a-pin-first': 'Veuillez entrer un NIP pour commencer.',
        'weak-password': 'Votre mot de passe est trop faible.',
        'invalid-date': 'Veuillez entrer une date valide.',
        'name-required': 'Vous devez spécifier le nom de la présentation.'
    },
    'services': {
        'auth-service': {
            'wrong-username-or-password': 'Nom d\'utilisateur ou mot de passe invalide.',
            'email-not-verified': 'Vous devez vérifier votre courriel'
        }
    },
    'components': {
        modal: {
            'auth-modal': {
                'requires-recent-login': 'Veuillez entrer votre mot de passe.'
            }
        },
        common: {
            'megabytes': 'Mo',
            'delete-confirm': 'Êtes-vous sûr(e) de vouloir supprimer définitivement cet objet?',
            'file-selector': {
                'max-file-size': 'Taille maximale du fichier',
                'accepted-files-types': 'Types de fichiers acceptés',
                'select-file': 'Veuillez sélectionner un fichier',
                'drop-file': 'Déposez le fichier.'
            },
            'json-editor': {
                'save-changes': 'Sauvegarder',
                'invalid-json': 'Le json fourni est invalide.'
            }
        },
        guards: {
            'pending-changes': {
                title: 'Changements non sauvegardés',
                subtitle: 'Si vous quittez la page, vous perdrez tous vos changements.',
                content: 'Voulez-vous tout de même quitter la page, ou bien poursuivre vos modifications ?',
                primaryAction: 'Poursuivre mes modifications',
                secondaryAction: 'Quitter la page'
            }
        }
    },
    'modules': {
        'layouts': {
            navigation: {
                'developer-tools': 'Outils développeur',
                'options': 'Options',
                'devices': 'Appareils',
                'presentations': 'Présentations',
                'home': 'Accueil',
                'configurations': 'Configurations'
            }
        },
        'editors': {
            'speed-option': {
                'Slow': 'Lente',
                'Normal': 'Normal',
                'Fast': 'Rapide'
            },
            nothing: {
                name: 'Rien',
                description: 'Cette section n\'affichera rien.'
            },
            unsupported: {
                'name': 'Non-supporté',
                'title': 'Le contenu n\'est plus supporté',
                'description': 'La section courante contient du contenu qui n\'est plus supporté. Vous pouvez copier les configurations afin de garder une copie de vos configurations.',
                'validation-error': 'Vous devez modifier la section qui n\'est plus supportée.'
            },
            header: {
                name: 'En-tête'
            },
            weather: {
                'name': 'Météo',
                'units': 'Unités',
                'cities': 'Villes',
                'celcius': 'Celcius',
                'fahrenheit': 'Fahrenheit',
                'no-cities-match': 'Aucune ville n\'a été trouvée',
                'no-cities-error': 'Vous devez sélectionner au moins une ville',
                'invalid-units-error': 'Vous devez sélectionner soit celcius, soit fahrenheit.',
                'enter-a-city-name': 'Entrez le nom d\'une ville',
                'weather-speed': 'Vitesse de transition',
                'invalid-speed-error': 'Vous devez sélectionner une vitesse de transition valide.'
            },
            news: {
                'name': 'Nouvelles',
                'badwords-default1': '<Mot à interdire 1>',
                'badwords-default2': '<Mot à interdire 2>',
                'and-so-on': '<...>',
                'sources-default1': '<Entrez l\'URL du fil rss 1>',
                'sources-default2': '<Entrez l\'URL du fil rss 2>',
                'logo-url-default': '<Entrez l\'URL du logo de votre nouvelle ici>',
                'title-default': '<Entrez le titre de votre nouvelle ici>',
                'content-default': '<Entrez le contenu de votre nouvelle ici>'
            },
            video: {
                'name': 'Vidéo',
                'current-video': 'Vidéo actuelle',
                'replace-video': 'Remplacer la vidéo',
                'aspect-ratio': 'Proportions de la vidéo',
                'Restrict': 'Ajustée',
                'Full': 'Zoom',
                'video-required': 'Vous devez téléverser une vidéo'
            },
            webpage: {
                'name': 'Page web',
                'url': 'Adresse de la page',
                'url-placeholder': 'Entrez l\'adresse complète de la page',
                'pending': 'Validation en cours',
                'valid': 'L\'adresse que vous avez entré est valide et pourra être affichée.',
                'invalid-url': 'L\'adresse que vous avez entré n\'est pas un url valide.',
                'website-prevent-embedding': 'Le détenteur de la page web empêche d\'incorporer son site dans une application externe.',
                'not-found': 'La page web n\'a pas été trouvée, veuillez valider l\'adresse fournie',
                'unauthorized': 'Vous devez vous authentifier pour accéder à la page en question. Veuillez contacter le détenteur du site en question afin de connaître la façon de procéder.',
                'forbidden': 'Vous n\'avez pas les droits pour accéder à cette page. Veuillez contacter le détenteur du site en question afin de connaître la façon de procéder.',
                'unknown': 'Une erreur inconnue c\'est produite lors de la vérification de l\'adresse. Vérifier l\'adresse ou communiquez avec le support technique.'
            },
            slideshow: {
                'name': 'Diaporama',
                'transition': 'Animation de transition',
                'slideshow-speed': 'Vitesse du diaporama',
                'display-mode': 'Mode d\'affichage',
                'transition-option': {
                    'NoAnimation': 'Aucune animation',
                    'FadeInFadeOut': 'Fondue'
                },
                'display-mode-option': {
                    'Restrict': 'Ajusté',
                    'Fill': 'Zoom',
                    'Blur': 'Ajusté avec arrière plan embrouillé'
                },
                'images-table': {
                    'title': 'Images',
                    'no-images': 'Aucune image téléchargée',
                    'name': 'Nom',
                    'order': 'Ordre',
                    'action': 'Action',
                    'add': 'Ajouter'
                },
                'delete-comfirm': 'Êtes-vous sûr de vouloir supprimer cette image du diaporama?',
                'no-image-error': 'Le diaporama doit contenir au moins une image.',
                'no-transition-speed-error': 'Le diaporama doit avoir une vitesse de transition valide.',
                'no-animation-error': 'Le diaporama doit avoir un type de transition valide.',
                'no-display-mode-error': 'Le diaporama doit avoir un mode d\'affichage valide.'
            }
        },
        'super-admin': {
            configurations: {
                'configurations': 'Configurations',
                'client-configurations': 'Configurations du client',
                'video': 'Vidéo',
                'saving-success': 'La configuration a été sauvegardée avec succès.',
                'saving-error': 'Échec lors de la sauvegarde du fichier de configurations.',
                'cant-load': 'Impossible de d\'obtenir le fichier de configurations.',
                'video-success': 'La vidéo a été mise à jour avec succès.',
                'video-error': 'Échec au téléversement de la vidéo.',
                'file-exceeds-maximum-size': 'Le fichier dépasse la taille limite autorisée.',
                'file-type-invalid': 'Le type du fichier est invalide.',
                'unknown-device': 'Désolé, cet appareil n\'existe pas.'
            }
        },
        'presentations': {
            list: {
                'title': 'Vos présentations',
                'create-presentation': 'Créer une présentation',
                'failed-to-retrieve-list': 'Une erreur s\'est produite lors de la récupération de vos présentations.',
                'failed-to-display-list': 'Une erreur s\'est produite lors de l\'affichage vos présentations.',
                'jumbotron-empty-presentation-list': {
                    'title': 'Créez votre première présentation',
                    'current-page-details': 'Vous êtes présentement sur la page des présentations. Vous retrouverez ici la liste de l\'ensemble de vos présentations.',
                    'instructions': 'Une présentation est nécessaire pour configurer les éléments visuels affichés à l\'écran de votre appareil. Pour créer votre première présentation, appuyez sur le bouton ci-dessous.'
                },
                'missing-description': 'Aucune description disponible.',
                'missing-name': 'Nom manquant',
                'missing-date': 'Date manquante'
            },
            edit: {
                'title': 'Configuration de la présentation',
                'error-getting-presentation': 'Une erreur est survenue lors de la récupération de la présentation.',
                'invalid-theme-error': 'Veuillez entrer un thème valide.',
                'last-modified': 'Dernière modification',
                'video': 'Vidéo',
                'new-presentation-default-name': 'Nom de votre présentation',
                'new-presentation-default-description': 'Description de votre présentation',
                'saving-success': 'La présentation a été sauvegardée avec succès.',
                'delete-success': 'La présentation à été supprimée.',
                'delete-confirm': 'Êtes-vous sûr(e) de vouloir supprimer définitivement la présentation?',
                'invalid-json': 'Le JSON est invalide.',
                'select-section': 'Sélectionnez une section de votre présentation pour la configurer.',
                'name-is-required': 'La présentation doit avoir un nom.',
                'file-upload-ongoing': 'Téléversement de vos fichiers en cours...',
                'some-sections-are-empty': 'Une ou plusieurs sections sont vides. Veullez remplir toutes les sections de votre présentation.',
                'name-label': 'Nom',
                'description-label': 'Description',
                'section-content': 'Contenu de la section',
                'layout': 'Arrangement',
                'theme': 'Thème',
                'black': 'Noir',
                'default': 'Noir',
                'white': 'Blanc',
                'blue': 'Bleu',
                'cactus': 'Cactus'
            }
        },
        'devices': {
            states: {
                state: 'État :',
                Unknown: 'Inconnu',
                Initializing: 'Initialisation',
                WaitingForPresentation: 'En attente d\'une présentation',
                LoadingPresentation: 'Chargement de la présentation',
                Unreachable: 'Inaccessible',
                Presenting: 'Affichage en cours',
                Shutdown: 'Arrêté'
            },
            link: {
                'no-device-info-box': {
                    title: 'Comment obtenir le NIP?',
                    content: 'Pour obtenir le NIP, vous devez alimenter votre appareil et y connecter un écran. Une série d\'instructions s\'affichera jusqu\'à ce que l\'appareil affiche son NIP de liaison.'
                },
                'title': 'Lier votre appareil',
                'link-success': 'L\'appareil a bien été lié à votre compte.',
                'naming-success': 'L\'appareil a bien été nommé.',
                'enter-your-pin': 'Entrez le NIP à quatres chiffres affiché sur l\'écran de votre appareil.',
                'name-your-device': 'Donnez un nom à votre appareil',
                'step-1': 'Lier',
                'step-2': 'Nommer',
                'step-3': {
                    title: 'Terminé!',
                    content: 'C\'est terminé! Appuyez sur un ou l\'autre des boutons ci-dessous afin de configurer votre nouvel appareil ou accéder à votre liste d\'appareils.'
                },
                'unnamed-device': 'Appareil sans nom'
            },
            list: {
                'title': 'Liste des appareils',
                'from-group': 'du groupe:',
                'your-devices': 'Vos appareils',
                'configure-group': 'Configuration du groupe',
                'failed-to-retrieve-list': 'Une erreur s\'est produite lors de la récupération de vos appareils.',
                'failed-to-display-list': 'Une erreur s\'est produite lors de l\'affichage vos appareils.',
                'link-new-device': 'Lier un nouvel appareil',
                'groups-list': 'Groupes d\'appareils',
                'create-web-view': 'Créer une vue web',
                'jumbotron-empty-device-list': {
                    'title': 'C\'est le temps de lier votre appareil!',
                    'current-page-details': 'Sur cette page de gestion des appareils, vous retrouverez la liste des appareils liés à votre compte. Vous pourrez également accéder à chacun de ces appareils afin de les configurer.',
                    'instructions': 'Pour lier votre appareil à ce compte administratif, alimentez l\'appareil, connectez-y un écran et suivez les instructions affichées. Lorsque l\'appareil affiche la combinaison de 4 chiffres, appuyez sur le bouton ci-bas pour établir la liaison.',
                    'button': 'Passer à l\'étape de liaison'
                }
            },
            edit: {
                'shared-config': {
                    'title': 'Configuration partagée',
                    'description': 'Plusieurs appareils peuvent appartenir au même groupe, ce qui vous permet de configurer plusieurs appareils simultanément. Activez cette option pour assigner un groupe à votre appareil ou créer un groupe à partir des configurations de cet appareil.',
                    'assign-group-title': 'Assigner un groupe à cet appareil'
                },
                'schedule': {
                    'advance-edit-title': 'Horaire de présentation',
                    'table-presentation': 'Présentation',
                    'table-startDate': 'Date début',
                    'table-endDate': 'Date fin',
                    'table-action': 'Action',
                    'delete-modal-message': 'Êtes-vous sûr(e) de vouloir supprimer cet horaire de la présentation?',
                    'edit-schedule-title': 'Configuration de l\'horaire de lecture',
                    'edit-schedule-presentation': 'Présentation',
                    'edit-schedule-startDate': 'Date de départ',
                    'edit-schedule-endDate': 'Date de fin',
                    'edit-schedule-12H24H': '12H / 24H',
                    'date-overlap': 'La date de départ doit se situer avant la date de fin.',
                    'no-schedule': 'Vous n\'avez aucun horaire de présentation. Appuyer sur ajouter pour en configurer un.',
                    'schedule-overlap': 'Une ou plusieurs plages horaires de présentation sont en conflit.',
                    'unactive-info': 'horaire(s) de présentation sont désactivée(s).'
                },
                'open-web-view': 'Ouvrir la vue web',
                'config-mode-title': 'Type de configuration',
                'device-schedule-title': 'Appareil',
                'shared-schedule-title': 'Groupe',
                'error-getting-device': 'Une erreur est survenue lors de la récupération de l\'appareil.',
                'title': 'Configuration de l\'appareil',
                'not-found': 'Cet appareil n\'existe pas.',
                'name-placeholder': 'Nom de l\'appareil',
                'name-is-needed': 'L\'appareil doit avoir un nom.',
                'configure-group': 'Configuration du groupe',
                'group-creation-success': 'Le groupe a été créé avec succès.',
                'error-creating-group': 'Une erreur est survenue lors de la création du groupe.',
                'error-refreshing-group': 'Une erreur est survenue lors du rafraichissement du groupe de l\'appareil.',
                'presentation': 'Présentation',
                'current-presentation-section': 'Présentation par défaut actuelle',
                'select-different-presentation': 'Sélectionner une présentation',
                'no-presentation': 'Aucune présentation',
                'error-getting-presentation': 'Une erreur est survenue lors de la récupération de la présentation de l\'appareil.',
                'no-presentation-instructions': 'Une présentation est nécessaire pour configurer les éléments visuels affichés à l\'écran de votre appareil en mode présentation. Pour créer votre première présentation, appuyez sur le bouton ci-dessous.',
                'no-timezone': 'Fuseau horaire non configuré.',
                'config-timezone-unavailable': 'Votre appareil ne supporte pas la gestion des fuseaux horaires.',
                'advanced-mode-section': 'Horaire des présentations',
                'activate-advanced-mode': 'Activer l\'horaire des présentations: ',
                'config-timezone-title': 'Configurer le fuseau horaire de l\'appareil',
                'config-timezone-subtitle': 'Configurer le fuseau horaire',
                'config-timezone-explanation': 'Afin d\'assurer la précision des changements de présentation planifiées, il est important que le fuseau horaire de votre appareil soit exact. Veuillez vérifier que le bon fuseau horaire a été détecté par l\'appareil, sinon veuillez le configurer.',
                'timezone-placeholder': 'Fuseau horaire',
                'timezone-off-note': '*Note: Si vous désactivez la configuration manuelle du fuseau horaire, votre appareil utilisera un système de géolocalisation pour la mettre à jour dès que possible.',
                'unlink': 'Délier l\'appareil',
                'unlink-confirm': 'Êtes-vous sûr(e) de vouloir délier l\'appareil de ce compte administratif?',
                'unlink-success': 'L\'appareil a été délié',
                'unlink-error': 'L\'appareil n\'a pas pu être délié',
                'saving-error': 'Échec lors de la sauvegarde de l\'appareil.',
                'saving-success': 'Les configurations de l\'appareil ont été sauvegardées avec succès.',
                'name-label': 'Nom',
                'group-conflict-modal': {
                    title: 'Souhaitez vous retirer cet appareil du groupe ou remplacer la configuration du groupe avec celle de l\'appareil?',
                    content: 'Les configurations de l\'appareil ont été modifiées, mais sont présentement écrasées par celles du groupe. Veuillez préciser l\'opération désirée.',
                    secondaryAction: 'Retirer l\'appareil du groupe',
                    primaryAction: 'Mettre à jour le groupe'
                }
            },
            groups: {
                'group': 'Groupe:',
                'group-of': 'Groupe de',
                'create-group': 'Créer un nouveau groupe',
                'list': {
                    'title': 'Vos groupes d\'appareils',
                    'failed-to-retrieve-list': 'Une erreur s\'est produite lors de la récupération de vos groupes d\'appareils.',
                    'failed-to-display-list': 'Une erreur s\'est produite lors de l\'affichage vos groupes d\'appareils.',
                    'no-device-in-group': 'Il n\'y a aucun appareil dans le groupe sélectionné.',
                    'jumbotron-empty-list': {
                        'title': 'Créez votre premier groupe d\'appareils',
                        'current-page-details': 'Vous êtes présentement sur la page des groupes d\'appareils. Vous retrouverez ici la liste de l\'ensemble de vos groupes d\'appareils.',
                        'instructions': 'Un groupe d\'appareils vous permet de configurer des paramètres qui pourront être partagés entre plusieurs appareils.'
                    }
                },
                'edit': {
                    'title': 'Configuration du groupe d\'appareils',
                    'group-devices-list': 'Liste des appareils du groupe',
                    'delete-success': 'Le groupe à été supprimée.',
                    'saving-success': 'Les configurations du groupe ont été sauvegardées avec succès.',
                    'saving-error': 'Une erreur s\'est produite lors de la sauvegarde du groupe',
                    'error-getting-device': 'Une erreur est survenue lors de la récupération du groupe.',
                    'error-missing-name': 'Un nom est requis pour la création du groupe.',
                    'new-default-name': 'Nom de votre groupe',
                    'delete-modal': {
                        'title': 'Êtes-vous sûr(e) de vouloir supprimer définitivement ce groupe?',
                        'content': 'Les appareils contenus dans le groupe vont être dissociés. Vous pouvez retourner aux configurations initiales des appareils ou copier la configuration du groupe dans les appareils.',
                        'override-device-config': 'Donner la configuration du groupe aux appareils',
                        'keep-device-config': 'Revenir aux configurations des appareils'
                    }
                }
            }
        },
        'user': {
            'email-action-handler': {
                'verify-email-success': 'Votre adresse courriel a bien été vérifiée. Vous pouvez maintenant vous connecter.',
                'email-recovery-success': 'Votre adresse courriel a bien été récupérée.',
                'change-password': 'Changer votre mot de passe.',
                'password-reset-success': 'Votre mot de passe a bien été modifié. Vous pouvez vous connecter.',
                'password': 'Mot de passe'
            },
            'verify-email': {
                'not-received': 'Si vous n\'avez pas reçu le courriel, cliquez sur le bouton suivant pour le renvoyer.',
                'not-verified': 'Veuillez vérifier votre courriel.',
                'success': 'Un message contenant les instructions pour vérifier votre adresse courriel vous a été envoyé.'
            },
            'login': {
                'welcome-to': 'Bienvenue sur',
                'username': 'Nom d\'utilisateur',
                'do-not-have-an-account': 'Vous n\'avez pas de compte?',
                'forgot-password': 'Mot de passe oublié',
                'password-recovery': 'Récupérer le mot de passe',
                'password': 'Mot de passe'
            },
            'create-account': {
                'create-an-account': 'Créer un compte',
                'already-have-an-account': 'Vous avez déjà un compte?',
                'email': 'Adresse courriel',
                'first-name': 'Prénom',
                'last-name': 'Nom',
                'password': 'Mot de passe',
                'characters': 'min. 8 caractères'
            },
            'forgot-password': {
                'create-an-account': 'Créer un compte',
                'forgot-password': 'Mot de passe oublié',
                'email': 'Email',
                'do-not-have-an-account': 'Vous n\'avez pas de compte?',
                'password-recovery': 'Récupérer le mot de passe',
                'success': 'Un couriel contenant les instructions pour réinitialiser votre mot de passe a été envoyé à votre adresse.'
            }
        },
        'home': {
            dashboard: {
                'welcome-to-prism-board': 'Bienvenue sur votre tableau de bord.',
                'jumbotron-guide-welcome': {
                    'current-page-details': 'Ne vous inquiétez pas, nous vous guiderons dans la configuration de votre appareil. Vous êtes présentement sur la page d\'accueil, le tableau de bord. Une fois la configuration terminé, vous retrouverez ici un aperçu de votre/vos appareil(s).',
                    'instructions': 'Complétez les tâches ci-dessous afin de configurer votre appareil.'
                },
                'task-no-presentation': {
                    'title': 'Créer une présentation',
                    'task-details': 'Une présentation est nécessaire pour configurer les éléments visuels affichés à l\'écran de votre appareil en mode présentation.'
                },
                'task-no-device': {
                    'task-details': 'Vous devez lier votre appareil à ce compte administratif pour le configurer.'
                },
                'devices-dashboard': {
                    'linked-devices': 'Vos appareils',
                    'name': 'Nom',
                    'group': 'Groupe',
                    'state': 'État',
                    'current-pres': 'Présentation courante',
                    'next-pres': 'Présentation suivante',
                    'next-start': 'Temps avant transition'
                }
            }
        },
        'account': {
            edit: {
                'title': 'Mon compte',
                'edit-account': 'Modifier le compte',
                'first-name': 'Prénom',
                'last-name': 'Nom',
                'email': 'Adresse courriel',
                'success': 'Votre compte a bien été mis à jour.',
                'account-details': 'Modifier le compte'
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/shared/i18n/fr-CA.ts